import styled from 'styled-components';

import Image from 'components/Image';

import { ORANGE, BLACK, BODY_TEXT } from 'root/theme';

const ShareHeadline = styled.h2`
  color: ${ORANGE};
  font-weight: 700;
  margin: 0;
`;

const ShareImage = styled(Image)`
  width: calc(100% - 4rem);
  border-radius: 30px;
  margin: 20px 0;
`;

const ShareText = styled.p`
  padding: 0 2rem 0.5rem;
  font-size: 1.25rem;
  ${BODY_TEXT}
`;

const ShareShareText = styled.div`
  max-width: 20rem;
  color: ${BLACK};
  font-weight: 600;
  margin: 1rem auto;
`;

export { ShareHeadline, ShareImage, ShareText, ShareShareText };
